<template>
  <info>
    <h1>{{ $t("PRIVACY POLICY") }}</h1>
    <div>
      <p>Nobody reads these long articles about Privacy. That's why we made it simple to comply with everything, even
        GDPR. </p>
      <h2>Information that we collect, how we use it, store, share and delete</h2>

      <ul>
        <li>Your email address. We use it to identify you in our systems. It is stored in our database. We only share it
          with our resellers over encrypted SSL/TLS channel to help them to simplify your checkout. It will be deleted
          immediately if you will unlink your device. </li>
        <li>Your device hardware identifiers. We use it to queue commands to your device. It is stored in our database.
          It will be deleted within 24h when you will unlink your device. Your device hardware identifier may be shared
          with our partner, if you will allow it. </li>
        <li>Your apps in your library. We store them on our servers hard discs. We never share it with anyone, unless
          you decided to make your app public. Your apps will be deleted in 5-10 minutes if there are no linked devices
          with your email. </li>
        <li>List of commands that were queued to your device in last 2 hours. It is stored in our database. Commands
          that older than 2 hours will be deleted, they also will be deleted within 24 hours if you will unlink your
          device. </li>
        <li>Your Apple Developer Cryptographic Identity and/or Keys to Access Apple systems (until interoperability will
          be implemented by Apple). It is stored in our database and passed only to our encrypted signing servers over
          encrypted SSL/TLS channel. After signing process is completed, identify will be removed from signing server.
          It will be removed from our servers completely when you will unlink you device. </li>
        <li>Cookies and LocalStorage. We use cookies and LocalStorage to identify your device or/and browser. Cookies
          are stored on your device/browser, and we will clear them if you will unlink your device. </li>
        <li>Your Name, Address, Download/Purchase history - it is stored in our database and kept unless you will
          request us to delete this information.</li>
        <li>Customer privacy and security is our top priority. We never store your passwords or sensitive banking
          information.</li>
      </ul>
    </div>
    <div>
      <h2>Information sharing policy</h2>
      <p>Your information (only: email address, your name, your billing address) may be shared with app developer who
        made an app that you are purchasing digital products or subscriptions in. This is required for tax and legal
        compliance.</p>
      <p>Your financial information is not shared with anyone (even us), as it is securely processed inside closed
        systems of payment processing company.</p>
      <p>Other information will not be shared with anyone, unless it is required by laws of Spain or defined above. </p>
      <p>Your email and name may be shared with duly verified developer in case of copyright claim resolution process,
        if you will approve this action.</p>
      <h2>Your right to request information about you</h2>
      <p>According to GDPR, you can request all information that is stored about you with us. Please email us to
        contact@dbservices.to and we will process your request within 7 business days. </p>

      <h2>3rd parties analytics</h2>
      <p>Our platform can contain scripts or/and pixels of 3rd party analytics tools like Google Adsense, Facebook,
        Twitter, Telegram. Please refer to Privacy Policies of 3rd parties in order to know how they use, store, share
        and delete your data. </p>
    </div>
    <div>
      <p>Updated 25 Jan 2026</p>
    </div>
  </info>
</template>

<script>
import Info from '@/components/Info';

export default {
  components: { Info },
  computed: {
    title() {
      return this.$t('PRIVACY POLICY');
    },
  },
};
</script>
